import { ReactElement } from 'react';
import InitialsAvatarStyled, { InitialsAvatarSize } from './InitialsAvatar.styled';

interface InitialsAvatarProps {
  firstName?: string;
  lastName?: string;
  size?: InitialsAvatarSize;
  className?: string;
}

const initialsOf = (firstName = '', lastName = ''): string => `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}`.toUpperCase();

const InitialsAvatar = ({ firstName, lastName, size = 'small', className }: InitialsAvatarProps): ReactElement => (
  <InitialsAvatarStyled.Circle $size={size} className={className} aria-hidden="true">
    {initialsOf(firstName, lastName)}
  </InitialsAvatarStyled.Circle>
);

export default InitialsAvatar;
